import { render, staticRenderFns } from "./Hojagrafica.vue?vue&type=template&id=7227775f"
import script from "./Hojagrafica.vue?vue&type=script&lang=js"
export * from "./Hojagrafica.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports